//
//  SDKWorkspaceSubscriptionPlanInterval.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Workspace subscription status internal enum
export var WorkspaceSubscriptionPlanInterval;
(function (WorkspaceSubscriptionPlanInterval) {
    /** The workspace is on a yearly plan */
    WorkspaceSubscriptionPlanInterval["yearly"] = "yearly";
    /** The workspace is on monthly plan */
    WorkspaceSubscriptionPlanInterval["monthly"] = "monthly";
})(WorkspaceSubscriptionPlanInterval || (WorkspaceSubscriptionPlanInterval = {}));
